import { Config } from "src/Utils/ConfigService/LoadConfig";
import { usePostRequest } from "../ApiWrappers/usePostRequest";
import { useCallback, useEffect, useRef, useState } from "react";
import { v1 } from "src/Utils/ApiVersions";
import { logger } from "src/Utils/LoggerService/LoggerService";

export enum AuraProductLicenseType {
    SuiteS = "SuiteS",
    SuiteM = "SuiteM",
    SuiteL = "SuiteL",
    Trail = "Trail",
    Demo = "Demo",
    Subscription = "Subscription",
    Permanent = "Permanent",
}

export enum SuiteMapping{
    SuiteS = "S",
    SuiteM = "M",
    SuiteL = "L",
    Trail = "Trail",
    Demo = "Demo",
    Subscription = "Subscription",
    Permanent = "Permanent"
}

export interface IPaymentProducts{
    currentPriceId: string;
    credit: number;
    suiteProductComboInfos: ISuiteProductComboInfos[];
}

export interface ISuiteProductComboInfos{
    productType: AuraProductLicenseType;
    currency: string;
    userSeats: number;
    storageInGb: number;
    monthlyInfo: IPaymentInfo;
    yearlyInfo: IPaymentInfo;
}

export interface IPaymentInfo{
    description: string;
    priceId: string;
    price: number;
    productId: string;
}

export const useGetPaymentProducts = () => {
    const {postRequest, reqestResponse, reqestError, reqestLoading} = usePostRequest();
    const [products, setProducts]  = useState<IPaymentProducts>();
    const baseUrl = Config.GetConfigData().auraLicensingService.serviceUrl;
    const clinicIdRef = useRef<string>('');
    const getPaymentProducts = useCallback((clinicId: string) => {
        const requestUrl = `${baseUrl}api/${v1}/payment/clinic/${clinicId}/product`;
        logger.logInformation(`Request to get payment products for the given clinic ${clinicId} was made`);
        postRequest<any>({}, requestUrl);
        clinicIdRef.current = clinicId;
    }, [baseUrl, postRequest]);

   useEffect(() => {
    if (reqestResponse) {
        setProducts(reqestResponse);
      }
    }, [reqestResponse]);

    return {products, reqestError, reqestLoading, getPaymentProducts};
}
